import React from 'react';
import { Flex, Stack, Text } from '@chakra-ui/react';


function Footer(){

    return(
      <Flex direction='column' minH={['70%','40%']} w='100%' bgColor='black' alignItems='center'>
        <Stack direction='column' w='70%' py={['5%','2%']}>
          <Text color='white' fontWeight='700' fontSize='md'>Pedro Serrano Gregorio</Text>
          <Text color='white' fontWeight='700' fontSize='md'>pedroserrano1b@gmail.com</Text>
          <Text color='white' fontWeight='700' fontSize='md'>+34 637340608</Text>
        </Stack>
      </Flex>
    );

}


export default Footer;